import { render } from "./author-intro.vue?vue&type=template&id=7af633a0&scoped=true"
import script from "./author-intro.vue?vue&type=script&lang=ts"
export * from "./author-intro.vue?vue&type=script&lang=ts"

import "./author-intro.vue?vue&type=style&index=0&id=7af633a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7af633a0"

export default script